import { phoneNumberNoFormatting } from 'packages/signup/helpers/validateSurvey';
import type { FormDetailsValues } from 'packages/signup/components/signupForm/types';

export default function sendDataWithoutFormatToPayload(companyLead: FormDetailsValues) {
  return {
    firstName: companyLead.firstName,
    lastName: companyLead.lastName,
    email: companyLead.email,
    companyName: companyLead.companyName,
    numberEmployees: companyLead.numberEmployees,
    phone: phoneNumberNoFormatting(companyLead.phone),
    password: companyLead.password,
    passwordConfirmation: companyLead.passwordConfirmation,
  };
}
